var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      on: {
        load: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      !_vm.frozen
        ? _c("article-preview", {
            attrs: { id: _vm.articleId, previewContentType: "external" }
          })
        : _vm._e(),
      _vm._v("\n  " + _vm._s(_vm.content) + "\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }